// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { messagesSparkle16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-messages-sparkle': IconMessagesSparkle;
    }
}

/**
 * The icon component for the 'messagesSparkle' icon
 */
export class IconMessagesSparkle extends IconSvg {
    public constructor() {
        super(messagesSparkle16X16);
    }
}

registerIconSvg('icon-messages-sparkle', IconMessagesSparkle);
export const iconMessagesSparkleTag = 'nimble-icon-messages-sparkle';
